import React from "react"
import { 
  Button, 
  TextField, 
  Checkbox, 
  FormControlLabel, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  Typography,
  Box,
  Container,
  Paper
} from "@mui/material"
import RoadSafetyGuideClaim4Accidents from '../img/LaborDay4thDraftCompressed.pdf'
import Navbar2 from "./NavBar2"
import BannerImg from '../img/BannerImg.png'
import Logo4Mobile from '../img/Logo4Mobile.svg'
import LaborDayGuidePreview from '../img/LaborDayGuidePreview.pdf'
import { 
  initializeEmailJS, 
  sendPdfFormEmails,
  sendPdfFormEmailsToBothServices,
  validatePdfFormData,
  testBothEmailServices,
  forceTriggerSecondaryService,
  testConditionalTrigger,
  diagnoseEmailJSConfiguration
} from '../html-email/emailjs-config'
import { sendStepperFormEmail } from './emailService'
// Function to get the initial landing URL
let initialLandingUrl = null;
 
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";
 
  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }
 
  return initialLandingUrl;
};
 
// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};


// Function to get Form Details
const getFormDetails = () => {
  const path = window.location.pathname; 

  if (path === "/" || path === "") {
    return { formname: "Home Form" };
  }

  const pageKey = path.replace("/", ""); 

  const readable = pageKey
    .replace(/Main$/i, "") 
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .trim();

  return { formname: `${readable} Form` };
};
// Add Rethink Sans font import
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://fonts.googleapis.com/css2?family=Rethink+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'
document.head.appendChild(link)

export default function PdfPage() {
  const [agreed, setAgreed] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [status, setStatus] = React.useState(null)
  const [showModal, setShowModal] = React.useState(false)
  
  const [pingUrl, setPingUrl] = useState("");
  const [certId, setCertId] = useState("");
  const [tokenUrl, setTokenUrl] = useState("");
  const [formData, setFormData] = React.useState({
    fullName: "",
    email: "",
    phone: "",
    consent: false
  })
  const [errors, setErrors] = React.useState({})
  const [emailjsLoaded, setEmailjsLoaded] = React.useState(false)
  const [isTestingEmails, setIsTestingEmails] = React.useState(false)

  // Load EmailJS script and initialize
  React.useEffect(() => {
    const loadEmailJS = () => {
      console.log('🔄 Loading EmailJS...')
      console.log('🌐 Window object:', typeof window !== 'undefined')
      console.log('📧 EmailJS in window:', window.emailjs ? 'Available' : 'Not available')
      
      if (typeof window !== 'undefined' && !window.emailjs) {
        console.log('📥 Creating EmailJS script tag...')
        const script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js'
        script.async = true
        script.onload = () => {
          console.log('✅ EmailJS script loaded successfully')
          initializeEmailJS()
          setEmailjsLoaded(true)
          console.log('🎉 EmailJS loaded and initialized')
        }
        script.onerror = () => {
          console.error('❌ Failed to load EmailJS script')
        }
        document.head.appendChild(script)
        console.log('📝 EmailJS script tag added to head')
      } else if (window.emailjs) {
        console.log('✅ EmailJS already available in window')
        initializeEmailJS()
        setEmailjsLoaded(true)
        console.log('🎉 EmailJS initialized from existing instance')
      }
    }

    loadEmailJS()
  }, [])

  // Replace with your own PDF URL if desired
  const PDF_URL = RoadSafetyGuideClaim4Accidents

  // PDF URL for preview modal
  const PREVIEW_PDF_URL = LaborDayGuidePreview

  // Function to format phone number
  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const phoneNumber = value.replace(/\D/g, '')
    
    // Limit to 10 digits
    if (phoneNumber.length > 10) return formData.phone
    
    // Format the number
    if (phoneNumber.length === 0) return ''
    if (phoneNumber.length <= 3) return `(${phoneNumber}`
    if (phoneNumber.length <= 6) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`
  }

  // Function to validate email
  const validateEmail = (email) => {
    // More comprehensive email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email.trim())
  }

  // Function to check if email contains @ symbol
  const hasAtSymbol = (email) => {
    return email.includes('@')
  }

  // Function to validate phone number
  const validatePhone = (phone) => {
    const phoneDigits = phone.replace(/\D/g, '')
    return phoneDigits.length === 10
  }

  // Function to validate full name
  const validateFullName = (name) => {
    return name.trim().length >= 2 && name.trim().includes(' ')
  }

  // Handle input changes
  const handleInputChange = (field, value) => {
    // Prevent numbers in full name field
    if (field === 'fullName') {
      // Remove any numbers from the input
      value = value.replace(/[0-9]/g, '')
    }
    
    setFormData(prev => ({ ...prev, [field]: value }))
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }))
    }

    // Real-time email validation
    if (field === 'email' && value) {
      if (!hasAtSymbol(value)) {
        setErrors(prev => ({ ...prev, email: 'Email must contain @ symbol' }))
      } else if (!validateEmail(value)) {
        setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }))
      } else {
        setErrors(prev => ({ ...prev, email: '' }))
      }
    }
  }

  // Update consent handling
  React.useEffect(() => {
    setFormData(prev => ({ ...prev, consent: agreed }))
  }, [agreed])
 useEffect(() => {
    let observer;
    let timeoutId;

    const initializeTrustedForm = () => {
      // Check for initial values
      const checkInitialValues = () => {
        const certUrlField = document.querySelector(
          'input[name="xxTrustedFormCertUrl"]'
        );
        const tokenField = document.querySelector(
          'input[name="xxTrustedFormCertToken"]'
        );
        const pingUrlField = document.querySelector(
          'input[name="xxTrustedFormPingUrl"]'
        );

        if (certUrlField?.value) {
          setCertId(certUrlField.value);
          // console.log("Initial cert_id:", certUrlField.value);
        }
        if (tokenField?.value) {
          setTokenUrl(tokenField.value);
          // console.log("Initial tokenUrl:", tokenField.value);
        }
        if (pingUrlField?.value) {
          setPingUrl(pingUrlField.value);
          // console.log("Initial pingUrl:", pingUrlField.value);
        }
      };

      // Set up mutation observer
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "value"
          ) {
            const fieldName = mutation.target.name;

            // Extract values from all TrustedForm fields
            const certUrlField = document.querySelector(
              'input[name="xxTrustedFormCertUrl"]'
            );
            const tokenField = document.querySelector(
              'input[name="xxTrustedFormCertToken"]'
            );
            const pingUrlField = document.querySelector(
              'input[name="xxTrustedFormPingUrl"]'
            );

            const certUrlValue = certUrlField?.value || "";
            const tokenValue = tokenField?.value || "";
            const pingUrlValue = pingUrlField?.value || "";

            // Update state with the correct values
            setCertId(certUrlValue);
            setPingUrl(pingUrlValue);
            setTokenUrl(tokenValue);

            // console.log("TrustedForm field update:", {
            //   fieldName,
            //   certId: certUrlValue,
            //   pingUrl: pingUrlValue,
            //   tokenUrl: tokenValue
            // });

            // Fetch cert data if we have a cert URL and it's the cert field that changed
            if (certUrlValue && fieldName === "xxTrustedFormCertUrl") {
              fetchCertData(certUrlValue);
            }
          }
        });
      });

      // Observe all TrustedForm fields for changes
      const fieldsToObserve = [
        "xxTrustedFormCertUrl",
        "xxTrustedFormCertToken",
        "xxTrustedFormPingUrl",
      ];

      fieldsToObserve.forEach((fieldName) => {
        const field = document.querySelector(`input[name="${fieldName}"]`);
        if (field) {
          observer.observe(field, { attributes: true });
          // console.log(`Observing field: ${fieldName}`);
        }
      });

      // Check for initial values after a delay to allow TrustedForm to load
      timeoutId = setTimeout(checkInitialValues, 1000);
    };

    // Initialize TrustedForm monitoring
    initializeTrustedForm();

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const fetchCertData = async (certUrl) => {
    try {
      const response = await fetch(certUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("TrustedForm Cert Data:", data);
      return data;
    } catch (error) {
      console.error("Error fetching TrustedForm cert:", error);
      return null;
    }
  };

  // Handle phone number change with formatting
  const handlePhoneNumberChange = (e) => {
    const formattedNumber = formatPhoneNumber(e.target.value)
    handleInputChange("phone", formattedNumber)
  }

  // Function to download the existing PDF
  const downloadExistingPDF = (userData) => {
    // Create a temporary link element
    const link = document.createElement('a')
    link.href = PDF_URL
    link.download = `RoadSafetyGuideClaim4Accidents-${userData.fullName.replace(/\s+/g, '-')}.pdf`
    
    // Append to body, click, and remove
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  // Test function for both email services
  const testEmailServices = async () => {
    console.log('🧪 Testing both email services...')
    setIsTestingEmails(true)
    
    try {
      const testResults = await testBothEmailServices()
      console.log('📊 Test results:', testResults)
      
      if (testResults.primary.success && testResults.secondary.success) {
        setStatus({ 
          type: "success", 
          message: "✅ Both email services are working! Check your inboxes." 
        })
      } else if (testResults.primary.success || testResults.secondary.success) {
        setStatus({ 
          type: "success", 
          message: "⚠️ One email service is working. Check console for details." 
        })
      } else {
        setStatus({ 
          type: "error", 
          message: "❌ Both email services failed. Check console for details." 
        })
      }
    } catch (error) {
      console.error('💥 Error testing email services:', error)
      setStatus({ 
        type: "error", 
        message: "❌ Error testing email services. Check console for details." 
      })
    } finally {
      setIsTestingEmails(false)
    }
  }

  // Force trigger secondary service
  const forceTriggerSecondary = async () => {
    console.log('🚀 Force triggering secondary service...')
    setIsTestingEmails(true)
    
    try {
      const result = await forceTriggerSecondaryService(formData)
      console.log('📊 Force trigger result:', result)
      
      if (result.success) {
        setStatus({ 
          type: "success", 
          message: "✅ Secondary service triggered successfully! Check your inbox." 
        })
      } else {
        setStatus({ 
          type: "error", 
          message: "❌ Secondary service failed. Check console for details." 
        })
      }
    } catch (error) {
      console.error('💥 Error force triggering secondary service:', error)
      setStatus({ 
        type: "error", 
        message: "❌ Error force triggering secondary service. Check console for details." 
      })
    } finally {
      setIsTestingEmails(false)
    }
  }

  // Test conditional trigger logic
  const testTriggerLogic = () => {
    console.log('🧪 Testing conditional trigger logic...')
    const shouldTrigger = testConditionalTrigger(formData)
    console.log('📊 Should trigger secondary service:', shouldTrigger)
    
    setStatus({ 
      type: shouldTrigger ? "success" : "error", 
      message: shouldTrigger ? 
        "✅ Conditions met! Secondary service will be triggered." : 
        "❌ Conditions not met. Secondary service will be skipped." 
    })
  }

  // Run EmailJS configuration diagnosis
  const runDiagnosis = () => {
    console.log('🔍 Running EmailJS configuration diagnosis...')
    const diagnosis = diagnoseEmailJSConfiguration()
    console.log('📊 Diagnosis complete. Check console for details.')
    
    setStatus({ 
      type: "success", 
      message: "🔍 Diagnosis complete! Check console for detailed configuration info and troubleshooting tips." 
    })
  }

async function handleSubmit(e) {
  e.preventDefault()
  console.log('🚀 Form submission started')
  setStatus(null)
  setErrors({})

  // Basic validation first
  if (!formData.fullName || formData.fullName.trim().length < 2) {
    setErrors({ fullName: "Please enter your full name (first and last name)" })
    return
  }
  
  if (!formData.fullName.includes(' ')) {
    setErrors({ fullName: "Please enter your full name (first and last name)" })
    return
  }
  
  if (!formData.email || !formData.email.includes('@')) {
    setErrors({ email: "Please enter a valid email address" })
    return
  }
  
  if (!formData.phone || formData.phone.replace(/\D/g, '').length !== 10) {
    setErrors({ phone: "Please enter a valid 10-digit phone number" })
    return
  }
  
  if (!agreed) {
    setStatus({ type: "error", message: "Please accept the terms and conditions." })
    return
  }

  console.log('✅ Basic validation passed, form data:', formData)
  console.log('📧 EmailJS loaded status:', emailjsLoaded)

  setIsSubmitting(true)
  
  // Create updatedFormData here so it's available in the entire function scope
  const updatedFormData = { ...formData, consent: agreed,certId,pingUrl,tokenUrl }
  console.log('📝 Updated form data with consent:', updatedFormData)
  
  try {
    // Check if the email function exists before calling it
    if (typeof sendPdfFormEmailsToBothServices === 'undefined') {
      console.warn('⚠️ sendPdfFormEmailsToBothServices is not available, falling back to basic email function')
      
      // Fallback to the basic email function
      if (typeof sendPdfFormEmails !== 'undefined') {
        await sendPdfFormEmails(updatedFormData)
      } else {
        console.warn('⚠️ No email functions available, skipping email sending')
      }
    } else {
      // Send emails to both admin services and user confirmation
      console.log('📧 Attempting to send emails to both admin services...')
      const emailResult = await sendPdfFormEmailsToBothServices(updatedFormData)
      console.log('📧 Email result:', emailResult)
    }
    
    // Send to backend API
    await fetch(
      'https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          countryName: 'Usa',
          brandName: 'Personal Injury',
          websiteName: 'Claim4Accidents',
          formname: getFormDetails().formname,
          data: {
            name: updatedFormData.fullName,
            email: updatedFormData.email,
            phone: updatedFormData.phone,
            ipAddress: await getIPAddress(),
            submissionDate: new Date().toISOString(),
            pageSource: getSourceUrl(),
            trustedFormToken: updatedFormData.certId,
      trustedFormPingUrl: updatedFormData.pingUrl,
      trustedFormCertUrl: updatedFormData.tokenUrl,
          },
        }),
      }
    );

    console.log('✅ Form submitted successfully')
    
    // Download the PDF after successful submission
    downloadExistingPDF(updatedFormData)
    
    // Success message
    setStatus({ 
      type: "success", 
      message: "Thank you! Your safety guide has been downloaded and we'll contact you soon." 
    })
    
    // Reset form
    setFormData({ fullName: "", email: "", phone: "", consent: false })
    setAgreed(false)
    
  } catch (error) {
    console.error('💥 Error in form submission:', error)
    
    // Try to download PDF anyway even if there were errors
    try {
      downloadExistingPDF(updatedFormData)
      setStatus({ 
        type: "success", 
        message: "Your safety guide has been downloaded. There was an issue with our contact system, so please reach out to us directly." 
      })
      setFormData({ fullName: "", email: "", phone: "", consent: false })
      setAgreed(false)
    } catch (downloadError) {
      console.error('💥 Error downloading PDF:', downloadError)
      setStatus({ 
        type: "error", 
        message: "There was an error processing your request. Please try again or contact us directly." 
      })
    }
  } finally {
    setIsSubmitting(false)
  }
}

  return (
    <main className="relative min-h-screen text-foreground rethink-sans-font" aria-label="Information and signup page" style={{ fontFamily: 'Rethink Sans, sans-serif' }}>
      {/* Navbar */}
      <Navbar2 />
      
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out"
        style={{
          backgroundImage: `url(${BannerImg})`,
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/55 transition-all duration-700 ease-in-out" aria-hidden="true" />

      {/* Content */}
      <div className="relative z-10 pt-20">
        <header className="px-4 py-6 md:px-8 transition-all duration-500 ease-in-out">
          <span className="sr-only">Company</span>
        </header>

        <section className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 pb-12 pt-2 md:grid-cols-2 md:gap-12 md:px-8 lg:py-8">
          {/* Left: Headings + PDF Preview CTA */}
          <div className="flex flex-col justify-center gap-6 text-white transition-all duration-700 ease-in-out">
            <h1 
              className="text-pretty leading-tight transition-all duration-500 ease-in-out hover:scale-105"
              style={{
                fontFamily: 'Rethink, sans-serif',
                fontWeight: 'bold',
                fontSize: 'clamp(28px, 5vw, 55px)',
                lineHeight: '1.1'
              }}
            >
              Make Every Mile Safe for Your Loved Ones
              <br />
              <span className="block mt-1">Get the Free Guide</span>
            </h1>
            <p 
              className="text-pretty leading-relaxed text-white/90 transition-all duration-500 ease-in-out"
              style={{
                fontFamily: 'Rethink Sans, sans-serif',
                fontWeight: '500',
                fontSize: 'clamp(14px, 3vw, 18px)',
                lineHeight: '1.4'
              }}
            >
              Don't hit the road without our essential Labor Day safety booklet. Learn how to prepare, prevent accidents, and travel confidently.
            </p>

            <Button
              variant="contained"
              onClick={() => setShowModal(true)}
              aria-label="Preview the PDF"
              className="hidden md:block"
              sx={{
                height: 48,
                px: 3,
                fontSize: '1rem',
                fontWeight: 600,
                backgroundColor: '#D14836',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(209, 72, 54, 0.3)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                width: 'fit-content',
                '&:hover': {
                  backgroundColor: '#b03d2e',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 40px rgba(209, 72, 54, 0.4)',
                  borderRadius: '16px'
                },
                '&:active': {
                  transform: 'translateY(0)',
                  boxShadow: '0 4px 20px rgba(209, 72, 54, 0.3)'
                }
              }}
            >
              Preview the PDF
            </Button>
          </div>

          {/* Right: Form */}
          <div className="flex transition-all duration-700 ease-in-out">
            <div
              className="w-full rounded-2xl border border-white/20 bg-white/95 p-6 shadow-2xl backdrop-blur-md md:p-8 transition-all duration-500 ease-in-out hover:shadow-3xl hover:bg-white hover:scale-[1.02]"
              role="region"
              aria-label="Request form"
              style={{
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)'
              }}
            >
              <h2 className="mb-3 text-2xl text-slate-900 md:text-3xl transition-all duration-300 ease-in-out">
                <span style={{ fontFamily: 'Rethink Sans, sans-serif', color: '#D14836' }} className="font-extrabold">ACT NOW!</span> <br/> 
                <span style={{ fontFamily: 'Rethink Sans, sans-serif', color: '#0A1F8F' }} className="font-bold">Get Your Free Safety Guide</span>
              </h2>
              {/* <p className="mb-6 text-base leading-relaxed text-slate-700 md:text-lg transition-all duration-300 ease-in-out">
              Fill out the form to receive our expert road safety guide instantly.
              </p> */}

              <form className="space-y-6" onSubmit={handleSubmit} noValidate>
                   {/* Hidden TrustedForm fields */}
                <input
                  type="hidden"
                  id="xxTrustedFormCertUrl"
                  name="xxTrustedFormCertUrl"
                  value={certId}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormCertToken"
                  name="xxTrustedFormCertToken"
                  value={tokenUrl}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormPingUrl"
                  name="xxTrustedFormPingUrl"
                  value={pingUrl}
                />
                <div className="transition-all duration-300 ease-in-out">
                  <TextField
                    id="fullName"
                    name="fullName"
                    label="Full name"
                    type="text"
                    placeholder="e.g. Mary Johnson"
                    required
                    fullWidth
                    variant="outlined"
                    value={formData.fullName}
                    onChange={(e) => handleInputChange("fullName", e.target.value)}
                    error={!!errors.fullName}
                    helperText={errors.fullName}
                    sx={{ 
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.fullName ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        },
                        '&.Mui-focused': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.fullName ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        }
                      }
                    }}
                  />
                </div>

                <div className="transition-all duration-300 ease-in-out">
                  <TextField
                    id="email"
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="you@example.com"
                    required
                    fullWidth
                    variant="outlined"
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    error={!!errors.email}
                    helperText={errors.email}
                    sx={{ 
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.email ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        },
                        '&.Mui-focused': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.email ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        }
                      }
                    }}
                  />
                </div>

                <div className="transition-all duration-300 ease-in-out">
                  <TextField
                    id="phone"
                    name="phone"
                    label="Phone number"
                    type="tel"
                    placeholder="(555) 123-4567"
                    required
                    fullWidth
                    variant="outlined"
                    value={formData.phone}
                    onChange={handlePhoneNumberChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    sx={{ 
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.phone ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        },
                        '&.Mui-focused': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: errors.phone ? '#d32f2f' : '#1d4ed8',
                            borderWidth: '2px'
                          }
                        }
                      }
                    }}
                  />
                </div>

                <div className="transition-all duration-300 ease-in-out">
                  <FormControlLabel
                    control={
                                              <Checkbox
                          id="terms"
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                          sx={{ 
                            color: '#D14836',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                              transform: 'scale(1.1)'
                            }
                          }}
                        />
                    }
                    label={
                      <div>
                        <Typography variant="body2" sx={{ fontWeight: 500, color: '#1e293b' }}>
                          I agree to the{" "}
                          <a href="/PrivacyPolicy" style={{ color: '#D14836', textDecoration: 'underline' }}>
                            Privacy Policy
                          </a>{" "}
                          &{" "}
                          <a href="/Disclaimer" style={{ color: '#D14836', textDecoration: 'underline' }}>
                            Disclaimer
                          </a>{" "}
                          & give my express written consent, affiliates & /or lawyer to contact you at the number provided above, even if this number is a wireless number or if I am presently listed on a Do Not Call list. I understand that I may be contacted by telephone, email, text message or mail regarding case options & that I may be called using automatic dialing equipment. Message & data rates may apply. My consent does not require purchase. This is Legal advertising.
                        </Typography>
                      </div>
                    }
                    sx={{ alignItems: 'flex-start', mb: 2 }}
                  />
                </div>

                {status && (
                  <Box
                    role="status"
                    sx={{
                      borderRadius: '12px',
                      px: 3,
                      py: 2,
                      bgcolor: status.type === "success" ? 'success.light' : 'error.light',
                      color: status.type === "success" ? 'success.dark' : 'error.dark',
                      mb: 2,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      animation: 'slideIn 0.5s ease-out'
                    }}
                  >
                    <Typography variant="body2">
                      {status.message}
                    </Typography>
                  </Box>
                )}

                <div className="pt-3 transition-all duration-300 ease-in-out">
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    fullWidth
                    sx={{
                      height: 56,
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      backgroundColor: '#D14836',
                      borderRadius: '16px',
                      boxShadow: '0 8px 32px rgba(209, 72, 54, 0.3)',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&:hover': {
                        backgroundColor: '#b03d2e',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 12px 40px rgba(209, 72, 54, 0.4)',
                        borderRadius: '20px'
                      },
                      '&:active': {
                        transform: 'translateY(0)',
                        boxShadow: '0 4px 20px rgba(209, 72, 54, 0.3)'
                      },
                      '&:disabled': {
                        opacity: 0.7,
                        transform: 'none',
                        boxShadow: '0 4px 20px rgba(209, 72, 54, 0.2)'
                      }
                    }}
                    aria-label="Download PDF"
                  >
                    {isSubmitting ? "Submitting..." : "Download Safety Guide →"}
                  </Button>
                  
                  {/* Test buttons for email services
                  <Button
                    onClick={testEmailServices}
                    disabled={isTestingEmails || !emailjsLoaded}
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mt: 2, 
                      height: 40,
                      borderColor: '#D14836',
                      color: '#D14836',
                      '&:hover': {
                        borderColor: '#b03d2e',
                        backgroundColor: 'rgba(209, 72, 54, 0.1)'
                      }
                    }}
                  >
                    {isTestingEmails ? "Testing..." : "🧪 Test Both Email Services"}
                  </Button>

                  <Button
                    onClick={forceTriggerSecondary}
                    disabled={isTestingEmails || !emailjsLoaded}
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mt: 1, 
                      height: 40,
                      borderColor: '#1d4ed8',
                      color: '#1d4ed8',
                      '&:hover': {
                        borderColor: '#1e40af',
                        backgroundColor: 'rgba(29, 78, 216, 0.1)'
                      }
                    }}
                  >
                    {isTestingEmails ? "Triggering..." : "🚀 Force Trigger Secondary Service"}
                  </Button>

                  <Button
                    onClick={testTriggerLogic}
                    disabled={isTestingEmails || !emailjsLoaded}
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mt: 1, 
                      height: 40,
                      borderColor: '#059669',
                      color: '#059669',
                      '&:hover': {
                        borderColor: '#047857',
                        backgroundColor: 'rgba(5, 150, 105, 0.1)'
                      }
                    }}
                  >
                    🔍 Test Trigger Conditions
                  </Button>

                  <Button
                    onClick={runDiagnosis}
                    disabled={isTestingEmails || !emailjsLoaded}
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mt: 1, 
                      height: 40,
                      borderColor: '#7c3aed',
                      color: '#7c3aed',
                      '&:hover': {
                        borderColor: '#6d28d9',
                        backgroundColor: 'rgba(124, 58, 237, 0.1)'
                      }
                    }}
                  >
                    🔍 Diagnose EmailJS Configuration
                  </Button> */}
                </div>

                {/* <p className="text-center text-sm text-slate-600 transition-all duration-300 ease-in-out">We'll never share your information.</p> */}
              </form>
            </div>
          </div>
        </section>

        {/* <footer className="px-4 pb-8 text-center text-white/70 md:px-8 transition-all duration-500 ease-in-out">
          <small>© {new Date().getFullYear()} Your Company</small>
        </footer> */}
      </div>

      {/* Modal */}
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '20px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }
        }}
      >
        <DialogTitle>
          <Typography variant="h5" component="h2">
            Benefits Guide (Preview)
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Scroll to read. You can also open the PDF in a new tab for larger controls.
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ 
              width: '100%', 
              overflow: 'hidden', 
              border: 1, 
              borderColor: 'divider', 
              bgcolor: 'background.paper',
              borderRadius: '12px',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            }}>
              <iframe
                src={PREVIEW_PDF_URL}
                title="Benefits Guide PDF"
                style={{ height: '70vh', width: '100%', border: 'none' }}
                aria-label="Benefits Guide PDF preview"
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
              <Button
                href={PREVIEW_PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: '#1d4ed8', 
                  borderRadius: '12px',
                  px: 3,
                  py: 1,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  marginLeft: 'auto',
                  '&:hover': {
                    backgroundColor: 'rgba(29, 78, 216, 0.1)',
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                Open in a new tab
              </Button>
              {/* <Button
                href={PDF_URL}
                download
                sx={{ 
                  color: '#1d4ed8', 
                  textDecoration: 'underline',
                  borderRadius: '12px',
                  px: 3,
                  py: 1,
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover': {
                    backgroundColor: 'rgba(29, 78, 216, 0.1)',
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                Download PDF
              </Button> */}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setShowModal(false)}
            sx={{
              borderRadius: '12px',
              px: 3,
              py: 1.5,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                transform: 'translateY(-1px)'
              }
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Apply Rethink Sans font to all text elements */
        .rethink-sans-font,
        .rethink-sans-font * {
          font-family: 'Rethink Sans', sans-serif !important;
        }
        
        /* Ensure form elements also use the font */
        .rethink-sans-font input,
        .rethink-sans-font textarea,
        .rethink-sans-font button,
        .rethink-sans-font label {
          font-family: 'Rethink Sans', sans-serif !important;
        }
        
        /* Apply to Material-UI components */
        .rethink-sans-font .MuiTypography-root,
        .rethink-sans-font .MuiButton-root,
        .rethink-sans-font .MuiTextField-root,
        .rethink-sans-font .MuiFormControlLabel-root {
          font-family: 'Rethink Sans', sans-serif !important;
        }
      `}</style>
    </main>
  )
}
